import "./loader.css";

const Loader = () => {
  return (
    <div className="lemon__loader-container">
      <div class=" lemon__loader"></div>
    </div>
  );
};

export default Loader;
